// jQuery
window.$ = window.jQuery = require('jquery');

// Bootstrap
window.Popper = require('popper.js').default;
require('bootstrap');

// TinyMCE editor
require('tinymce/tinymce');

// Moment.js
window.moment = require('moment');
require('moment/locale/it');

//Date Range Picker
require('daterangepicker');

// Start Bootstrap 2
require('./sb-admin-2');

// DataTables
require('datatables.net');
require('datatables.net-bs4');
require( 'datatables.net-fixedcolumns' );
require( 'datatables.net-fixedcolumns-bs4' );

// Select 2
require("select2");

// Chart.js
require('chart.js');
window.ChartAnnotation = require('chartjs-plugin-annotation');


// jQuery.Easing
require('jquery.easing');

// Polyfills
if ("ActiveXObject" in window) { // IE11
    console.warn('Import core-js')
    require('core-js');
}

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$.fn.dataTable.ext.errMode = 'none';

$(document).ready(function() {

    require('flatpickr');
    global.monthSelectPlugin = require("flatpickr/dist/plugins/monthSelect");

    $('.daterangepicker').daterangepicker();

    if(typeof flatpickr !== 'undefined') flatpickr.localize( require("flatpickr/dist/l10n/it.js").default.it );
    $(".datepicker").flatpickr({
        altInput: true,
        altFormat: "j F Y",
        dateFormat: "Y-m-d"
    });
    $(".datepicker-nopast").flatpickr({
        altInput: true,
        altFormat: "j F Y",
        dateFormat: "Y-m-d",
        minDate: 'today'
    });
    $(".datepicker-time").flatpickr({
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
    });
    $(".datepicker-month").flatpickr({
        altInput: true,
        plugins: [
            new monthSelectPlugin({
                shorthand: true,
                dateFormat: "Y-m",
                altFormat: "F Y",
                theme: "light"
            })
        ]
    });

    require('select2');

    $('.select2').select2({
        placeholder: 'Cerca...',
        theme: 'bootstrap4',
    });
});

window.getTinyMCESettings = function(customSettings) {
    const defaults = {
        branding: false,
        base_url: '/assets/js'
    };

    return {
        ...defaults,
        ...customSettings
    }
}

require('./cms/cms-common');
require('./cms/cms-table');

$(function(){
    $('body').tooltip({
        selector: '[data-toggle="tooltip"]',
        boundary: 'window',
    });
});
